import { EventModel } from 'features/events/EventModel';
import { liveEventSelector } from 'features/events/eventsSelectors';
import { useEffect, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useAudio } from 'features/audio/audio';
import { useAppSelector } from 'hooks/redux';

export const useAutoPlayEventAfterNavigation = (event: EventModel | null) => {
  const location = useLocation() as any;
  const { loadAudio } = useAudio();
  const audioUrl = useAppSelector((state) => state.audio.url);
  const audioIsPlaying = useAppSelector((state) => state.audio.playing);
  const { isNativeAppWebview, isBrowserEmbed } = useContext(UserAgentContext);
  const isAnimatingLayout = useAppSelector(
    (state) => state.ui.isAnimatingLayout
  );
  const liveEvent: EventModel | null = useAppSelector(liveEventSelector);
  const hasLoadedAudioRef = useRef<boolean>(false);

  // Capture latest loadAudio in a ref so the effect doesn't re-fire on its
  // identity changes; we drive off primitive deps only.
  const loadAudioRef = useRef(loadAudio);
  loadAudioRef.current = loadAudio;

  const eventId = event?.id;
  const liveEventId = liveEvent?.id;
  const shouldAutoPlay = !!(location.state && location.state.autoPlay);

  useEffect(
    function autoPlayAudioAfterNavigation() {
      if (isNativeAppWebview || isBrowserEmbed || isAnimatingLayout) return;
      if (!audioUrl) return;
      if (liveEventId && eventId !== liveEventId) return;
      if (audioIsPlaying) return;
      if (hasLoadedAudioRef.current) return;
      if (shouldAutoPlay) {
        console.log(
          '[useAutoPlayEventAfterNavigation] - Auto playing event audio after navigating'
        );
        loadAudioRef.current({
          audioSrc: audioUrl,
          autoPlay: true,
          audioType: 'event'
        });
        hasLoadedAudioRef.current = true;
      }
    },
    [
      isNativeAppWebview,
      isBrowserEmbed,
      isAnimatingLayout,
      audioUrl,
      audioIsPlaying,
      eventId,
      liveEventId,
      shouldAutoPlay
    ]
  );
};
